var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 143,
    viewBox: "0 0 248 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5011_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 248,
    height: 143
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M247.5 0H0.5V143H247.5V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5011_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.1519 12.5566C50.2192 12.5566 45.6153 15.1873 43.3134 19.4623L26.8711 47.4143L34.7634 52.0181L50.548 25.3816C51.8634 23.4085 54.1653 22.0931 56.4672 22.0931H114.344V12.5566H55.1519Z",
    fill: "url(#paint0_linear_5011_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.82 60.8965H125.524V102.331H103.82V60.8965Z",
    fill: "url(#paint1_linear_5011_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.82 60.8965H125.524V102.331H103.82V60.8965Z",
    fill: "url(#paint2_linear_5011_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.545 43.4668H145.257C142.626 43.4668 140.324 44.4533 138.68 46.4264L125.855 60.8956V102.33L138.68 116.799C140.324 118.773 142.955 119.759 145.257 119.759H148.545C153.478 119.759 157.424 115.813 157.424 110.88V52.3456C157.424 47.413 153.478 43.4668 148.545 43.4668Z",
    fill: "url(#paint3_linear_5011_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3762 123.377C6.15505 123.377 -0.421875 116.8 -0.421875 108.578V54.6477C-0.421875 46.4265 6.15505 39.8496 14.3762 39.8496H94.9435C103.164 39.8496 109.741 46.4265 109.741 54.6477V108.907C109.741 117.128 103.164 123.705 94.9435 123.705H14.3762V123.377Z",
    fill: "url(#paint4_linear_5011_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3749 117.458C9.44225 117.458 5.49609 113.512 5.49609 108.579V54.6484C5.49609 49.7157 9.44225 45.7695 14.3749 45.7695H94.9422C99.8749 45.7695 103.821 49.7157 103.821 54.6484V108.908C103.821 113.841 99.8749 117.787 94.9422 117.787H14.3749V117.458Z",
    fill: "url(#paint5_linear_5011_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9422 45.7695C99.8749 45.7695 103.821 49.7157 103.821 54.6484V108.908C103.821 113.841 99.8749 117.787 94.9422 117.787H14.3749C9.44225 117.787 5.49609 113.841 5.49609 108.908V54.6484C5.49609 49.7157 9.44225 45.7695 14.3749 45.7695H94.9422Z",
    fill: "url(#paint6_linear_5011_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.824 108.579V75.6946L89.0257 60.8965L20.2969 102.66L35.095 117.458H94.945C99.8777 117.458 103.824 113.512 103.824 108.579Z",
    fill: "url(#paint7_linear_5011_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2969 58.9238H88.6969V104.305H20.2969V58.9238Z",
    fill: "url(#paint8_linear_5011_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9297 17.1596C95.9297 22.4211 100.205 26.6961 105.466 26.6961H115.989C121.251 26.6961 125.526 22.4211 125.526 17.1596C125.526 11.898 121.251 7.62305 115.989 7.62305H105.466C100.205 7.62305 95.9297 11.898 95.9297 17.1596Z",
    fill: "url(#paint9_linear_5011_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.5 8L157.5 57.7769V102.101L246.5 143V8Z",
    fill: "url(#paint10_linear_5011_2)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5011_2",
    x1: 70.5287,
    y1: 7.21285,
    x2: 70.5287,
    y2: 23.5565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C5C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2943"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5011_2",
    x1: 114.672,
    y1: 69.2623,
    x2: 114.672,
    y2: 105.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C5C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2943"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5011_2",
    x1: 114.672,
    y1: 89.3844,
    x2: 114.672,
    y2: 99.4241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C5C75",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2943"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5011_2",
    x1: 154.76,
    y1: 81.6524,
    x2: 134.753,
    y2: 81.6524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C5C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2943"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5011_2",
    x1: 54.719,
    y1: 33.3779,
    x2: 54.719,
    y2: 108.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C5C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2943"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5011_2",
    x1: 54.7178,
    y1: 108.369,
    x2: 54.7178,
    y2: 37.6207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C5C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2943"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5011_2",
    x1: 54.7178,
    y1: 122.23,
    x2: 54.7178,
    y2: 61.1957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C5C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2943"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5011_2",
    x1: 92.9587,
    y1: 122.239,
    x2: 56.049,
    y2: 82.5181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C5C75",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2587,
    stopColor: "#475670",
    stopOpacity: 0.181
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5896,
    stopColor: "#384760",
    stopOpacity: 0.413
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9584,
    stopColor: "#202C46",
    stopOpacity: 0.671
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2943",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5011_2",
    x1: 54.7205,
    y1: 82.9032,
    x2: 54.7205,
    y2: 101.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E7F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA9C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5011_2",
    x1: 95.8344,
    y1: 17.1958,
    x2: 125.802,
    y2: 17.1958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C5C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2943"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5011_2",
    x1: 156.5,
    y1: 74.7059,
    x2: 246.994,
    y2: 75.9651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D879A",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D8899",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.d2967ad218a1ac41e057727639a411d2.svg";
export { ForwardRef as ReactComponent };